/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DutyScheduleDistributionRowResponse
 */
export interface DutyScheduleDistributionRowResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDistributionRowResponse
     */
    counselorId: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDistributionRowResponse
     */
    userCode: string;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionRowResponse
     */
    weeklyHours: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionRowResponse
     */
    aw12: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionRowResponse
     */
    aw3: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionRowResponse
     */
    bgs: number;
}

/**
 * Check if a given object implements the DutyScheduleDistributionRowResponse interface.
 */
export function instanceOfDutyScheduleDistributionRowResponse(value: object): value is DutyScheduleDistributionRowResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('weeklyHours' in value) || value['weeklyHours'] === undefined) return false;
    if (!('aw12' in value) || value['aw12'] === undefined) return false;
    if (!('aw3' in value) || value['aw3'] === undefined) return false;
    if (!('bgs' in value) || value['bgs'] === undefined) return false;
    return true;
}

export function DutyScheduleDistributionRowResponseFromJSON(json: any): DutyScheduleDistributionRowResponse {
    return DutyScheduleDistributionRowResponseFromJSONTyped(json, false);
}

export function DutyScheduleDistributionRowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleDistributionRowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'userCode': json['userCode'],
        'weeklyHours': json['weeklyHours'],
        'aw12': json['aw12'],
        'aw3': json['aw3'],
        'bgs': json['bgs'],
    };
}

export function DutyScheduleDistributionRowResponseToJSON(json: any): DutyScheduleDistributionRowResponse {
    return DutyScheduleDistributionRowResponseToJSONTyped(json, false);
}

export function DutyScheduleDistributionRowResponseToJSONTyped(value?: DutyScheduleDistributionRowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'userCode': value['userCode'],
        'weeklyHours': value['weeklyHours'],
        'aw12': value['aw12'],
        'aw3': value['aw3'],
        'bgs': value['bgs'],
    };
}

